export abstract class Utils {
    private static uriValidator = /^http(s)?:\/\/(www\.)?[a-zA-Z0-9_]+([\-\.]{1}[a-zA-Z0-9]+)*((\.[a-zA-Z]{2,5})|(\.[0-9]{1,3}))(:[0-9]{1,5})?(\/.*)?$/;
    private static guidValidator = new RegExp("^[{(]?[0-9A-Fa-f]{8}[-]?([0-9A-Fa-f]{4}[-]?){3}[0-9A-Fa-f]{12}[)}]?$");

    public static isUriValid(uri: string): boolean {
        return Utils.uriValidator.test(uri);
    }

    public static isGuidValid(guid: string): boolean {
        return Utils.guidValidator.test(guid) && guid !== "00000000-0000-0000-0000-000000000000";
    }

    public static isNullOrEmpty(value: string) {
        return (value == null || value.trim() === "");
    }
}


/** WEBPACK FOOTER **
 ** ./app/utils/utils.ts
 **/